// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__j1MHj","inputWrap":"styles_inputWrap__3E_8-","input":"styles_input__Mi10O"};